import { Divider, Row } from "antd";
import { FixtureView } from "components/FixtureView/FixtureView";
import { BackToButton } from "components/Shared/BackToButton";
import { FixtureTitle } from "components/Shared/FixtureTitle";
import { useFetchFixtureRoster } from "hooks/useFixtureRosterApi";
import { useFetchFixtureStaff } from "hooks/useFixtureStaffApi";
import { useFetchFixture } from "hooks/useFixturesApi";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

export const AdminFixturePage = () => {
  const {
    customerId,
    organizationId,
    sport,
    entityId: entityIdFromParams,
    seasonId: seasonIdFromParams,
    fixtureId: fixtureIdFromParams,
  } = useParams();
  const entityId = entityIdFromParams || "undefined";
  const seasonId = seasonIdFromParams || "undefined";
  const fixtureId = fixtureIdFromParams || "undefined";
  const { formatMessage } = useIntl();
  const { data: fixtureResponse, isLoading: isFixtureLoading } = useFetchFixture({
    entityId,
    seasonId,
    fixtureId,
  });
  const fixture = fixtureResponse?.data?.[0];
  const { data: fixtureRosterResponse, isLoading: isFixtureRosterLoading } = useFetchFixtureRoster({
    entityId,
    seasonId,
    fixtureId,
  });
  const roster = fixtureRosterResponse?.data || [];
  const { data: fixtureStaffResponse, isLoading: isFixtureStaffLoading } = useFetchFixtureStaff({
    entityId,
    seasonId,
    fixtureId,
  });
  const staff = fixtureStaffResponse?.data || [];

  const isLoading = isFixtureLoading || isFixtureRosterLoading || isFixtureStaffLoading;

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <FixtureTitle isLoading={isLoading} fixture={fixture} />
        <BackToButton
          to={`/${customerId}/${sport}/${organizationId}/admin`}
          btnText={formatMessage({ id: "back.to.dashboard" })}
        />
      </Row>
      <Divider />
      <FixtureView
        viewOnly={true}
        isLoading={isLoading}
        fixture={fixture}
        roster={roster}
        staff={staff}
        entityId={entityId}
      />
    </>
  );
};
